import React from 'react'
import PropTypes from 'prop-types'
import { isIframe } from 'iframe-support'
import Overpanel from 'react-components/overpanel'
import { connect } from 'transfer/utils/p2p-connect'
import * as OverpanelActions from 'transfer/actions/overpanels'
import ErrorContent from './errorContent'

function ConfirmIdentityOverpanel(props) {
  const { dispatch, shouldShowConfirmIdentityOverpanel, cdnHostName } = props

  const closeOverpanel = () => {
    dispatch(OverpanelActions.toggleConfirmIdentityOverpanel({ show: false }))
  }

  const onConfirm = () => {
    const mainWindow = isIframe() ? window.top : window
    mainWindow.location = '/policy/hub/cip'
  }

  const onClose = () => {
    closeOverpanel()
  }

  return (
    <Overpanel handleClose={onClose} show={shouldShowConfirmIdentityOverpanel}>
      <ErrorContent
        onConfirm={onConfirm}
        onCancel={onClose}
        cdnHostName={cdnHostName}
      />
    </Overpanel>
  )
}

ConfirmIdentityOverpanel.propTypes = {
  dispatch: PropTypes.func.isRequired,
  shouldShowConfirmIdentityOverpanel: PropTypes.bool.isRequired,
  cdnHostName: PropTypes.string.isRequired,
}

export default connect(({ overpanels, server }) => ({
  shouldShowConfirmIdentityOverpanel:
    overpanels.shouldShowConfirmIdentityOverpanel,
  cdnHostName: server.cdnHostName,
}))(ConfirmIdentityOverpanel)
